export enum CacheEntityIdentifier {
  CampaignV5 = 'CampaignV5',
  LineItemV5 = 'LineItemV5',
  AdV5 = 'AdV5',
}

export type OldCacheData<T> = {
  cacheId: string;
  cacheData: Partial<T>;
};
